import { useCallback, useMemo } from 'react';
import {
  skillCommandState,
  useAppDispatch,
  useAppSelector,
  setActiveSkillCommand,
} from 'src/store';
import { QuickSkillCommand } from 'src/types';

export const useSkillCommand = () => {
  const { activeSkillCommand } = useAppSelector(skillCommandState);

  const dispatch = useAppDispatch();

  const toggleActiveSkillCommand = useCallback(
    (command: QuickSkillCommand | null) => {
      const toggleValue = command === activeSkillCommand ? null : command;

      dispatch(setActiveSkillCommand(toggleValue));
    },
    [activeSkillCommand, dispatch],
  );

  return useMemo(
    () => ({
      isCompareModeSkills:
        activeSkillCommand === QuickSkillCommand.WRITER ||
        activeSkillCommand === QuickSkillCommand.RESEARCHER,
      isThinkEnabled: activeSkillCommand === QuickSkillCommand.THINKING,
      activeSkillCommand,
      toggleActiveSkillCommand,
    }),
    [activeSkillCommand, toggleActiveSkillCommand],
  );
};
